/**
 * Privy SDK 工具函数
 * 解决 viem 在某些 RPC 错误时不正确 reject Promise 的问题
 */

/**
 * 包装 Privy sendTransaction，捕获 unhandledrejection
 * 
 * 问题背景：
 * Privy 的 sendTransaction 内部使用 viem，当 RPC 返回某些错误时（如 InvalidInputRpcError），
 * viem 会抛出 unhandled rejection 而不是正常 reject Promise，导致 try-catch 无法捕获错误。
 * 
 * @param sendFn 执行交易的函数
 * @param timeout 超时时间（毫秒），默认 30 秒
 * @returns Promise<T>
 */
export const safeSendTransaction = async <T>(
  sendFn: () => Promise<T>,
  timeout: number = 30000
): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    let settled = false;

    // 监听 unhandledrejection 事件
    const unhandledHandler = (event: PromiseRejectionEvent) => {
      if (!settled) {
        settled = true;
        event.preventDefault();
        window.removeEventListener('unhandledrejection', unhandledHandler);
        reject(event.reason);
      }
    };
    window.addEventListener('unhandledrejection', unhandledHandler);

    // 执行交易
    sendFn()
      .then((result) => {
        if (!settled) {
          settled = true;
          window.removeEventListener('unhandledrejection', unhandledHandler);
          resolve(result);
        }
      })
      .catch((error) => {
        if (!settled) {
          settled = true;
          window.removeEventListener('unhandledrejection', unhandledHandler);
          reject(error);
        }
      });

    // 超时处理
    setTimeout(() => {
      if (!settled) {
        settled = true;
        window.removeEventListener('unhandledrejection', unhandledHandler);
        reject(new Error('交易超时，请重试'));
      }
    }, timeout);
  });
};















